import { cx } from "./primitives";

/**
 * The app's accent ring spinner. Extracted so the ~dozen hand-rolled copies of
 * this exact div collapse to one. `size` is the diameter in px (default 24).
 */
export function Spinner({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <div
      role="status"
      aria-label="Loading"
      style={{ width: size, height: size, borderWidth: Math.max(2, Math.round(size / 12)) }}
      className={cx(
        "animate-spin rounded-full border-[var(--color-edge)] border-t-[var(--color-accent)]",
        className,
      )}
    />
  );
}
